// extracted by mini-css-extract-plugin
export default {"whited":"XTable_whited__l-M0k","table_bottom":"XTable_table_bottom__pU87m"};